/* Custom Slidecart JS für nanozahnbuerste.de (Broadcast-Theme).
   Priorisierter Versand (verstecktes Produkt via Cart API), Upsell-Karussell
   (Add-Buttons, in-Cart-Ausblendung, Scroll-Fade), Versandzeile, Progress-Bar.
   Broadcast hat kein Cart-Change-Event – Updates werden über einen
   MutationObserver auf [data-cart-total] erkannt. */

(function () {
  'use strict';

  var cartCache = {promise: null, time: 0};

  function fetchCart() {
    var now = Date.now();
    if (cartCache.promise && now - cartCache.time < 300) return cartCache.promise;
    cartCache.time = now;
    cartCache.promise = fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function (r) {
      return r.json();
    });
    return cartCache.promise;
  }

  function refreshCartUI() {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
    } else {
      window.location.reload();
    }
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  var updateHandlers = [];

  function onCartUpdate(fn) {
    updateHandlers.push(fn);
    fn();
  }

  function fireUpdate() {
    cartCache.promise = null;
    updateHandlers.forEach(function (fn) { fn(); });
  }

  /* Cart-Updates erkennen: Broadcast schreibt bei jedem getCart() den Total neu */
  function initUpdateObserver() {
    var total = document.querySelector('.cart-dropdown [data-cart-total]');
    if (!total) return;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(fireUpdate, 120);
    }).observe(total, {childList: true, characterData: true, subtree: true});
  }

  /* Header-Zähler im Drawer */
  function initHeaderCount() {
    var holder = document.querySelector('[data-slidecart-count]');
    if (!holder) return;
    onCartUpdate(function () {
      fetchCart().then(function (cart) {
        holder.textContent = cart.item_count;
      });
    });
  }

  /* Priorisierter Versand */
  function initPriority() {
    var holder = document.querySelector('[data-slidecart-priority]');
    if (!holder) return;
    var toggle = holder.querySelector('[data-slidecart-priority-toggle]');
    var variantId = parseInt(holder.getAttribute('data-variant-id'), 10);
    if (!toggle || !variantId) return;

    function sync() {
      fetchCart().then(function (cart) {
        var line = cart.items.find(function (i) { return i.variant_id === variantId; });

        if (line && cart.items.length === 1) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: line.key, quantity: 0}),
          }).then(function () {
            toggle.checked = false;
            holder.classList.remove('is-loading');
            refreshCartUI();
          });
          return;
        }

        toggle.checked = Boolean(line);
        holder.classList.remove('is-loading');
      });
    }

    toggle.addEventListener('change', function () {
      holder.classList.add('is-loading');

      if (toggle.checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: variantId, quantity: 1}),
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) toggle.checked = false;
            holder.classList.remove('is-loading');
            refreshCartUI();
          })
          .catch(function () {
            toggle.checked = false;
            holder.classList.remove('is-loading');
          });
      } else {
        fetchCart().then(function (cart) {
          var line = cart.items.find(function (i) { return i.variant_id === variantId; });
          if (!line) { holder.classList.remove('is-loading'); return; }

          fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: line.key, quantity: 0}),
          }).then(function () {
            holder.classList.remove('is-loading');
            refreshCartUI();
          });
        });
      }
    });

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-slidecart-priority-info]');
      if (btn) holder.classList.toggle('is-info-open');
    });

    onCartUpdate(sync);
  }

  /* Upsell-Karussell */
  function initUpsell() {
    var carousel = document.querySelector('[data-slidecart-upsell]');
    if (!carousel) return;
    var track = carousel.querySelector('[data-slidecart-upsell-track]');
    if (!track) return;

    function updateScrollEnd() {
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      carousel.classList.toggle('is-scroll-end', atEnd);
    }

    track.addEventListener('scroll', updateScrollEnd, {passive: true});

    // Einmalig/Spar-Abo-Umschalter und Intervall-Chips (Recharge Selling Plans)
    carousel.addEventListener('click', function (event) {
      var modeBtn = event.target.closest('[data-mode]');
      if (modeBtn) {
        var slide = modeBtn.closest('[data-slidecart-upsell-slide]');
        var isAbo = modeBtn.getAttribute('data-mode') === 'abo';

        slide.classList.toggle('is-abo', isAbo);
        slide.querySelectorAll('[data-mode]').forEach(function (b) {
          b.classList.toggle('is-active', b === modeBtn);
        });

        var plans = slide.querySelector('[data-upsell-plans]');
        if (plans) plans.hidden = !isAbo;

        var price = slide.querySelector('[data-upsell-price]');
        var compare = slide.querySelector('[data-upsell-compare]');
        if (price) {
          price.textContent = isAbo ? price.getAttribute('data-price-abo') : price.getAttribute('data-price-onetime');
        }
        if (compare) {
          var compareValue = isAbo ? compare.getAttribute('data-compare-abo') : compare.getAttribute('data-compare-onetime');
          compare.hidden = !compareValue;
          compare.textContent = compareValue || '';
        }
        return;
      }

      var planBtn = event.target.closest('[data-plan-id]');
      if (planBtn) {
        planBtn.closest('[data-upsell-plans]').querySelectorAll('[data-plan-id]').forEach(function (b) {
          b.classList.toggle('is-active', b === planBtn);
        });
        return;
      }

      // Add-Button: im Abo-Modus mit selling_plan hinzufügen
      var btn = event.target.closest('[data-slidecart-add]');
      if (!btn) return;

      var addSlide = btn.closest('[data-slidecart-upsell-slide]');
      var body = {id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1};

      if (addSlide && addSlide.classList.contains('is-abo')) {
        var activePlan = addSlide.querySelector('[data-plan-id].is-active');
        if (activePlan) body.selling_plan = parseInt(activePlan.getAttribute('data-plan-id'), 10);
      }

      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.classList.remove('is-loading');
          refreshCartUI();
        })
        .catch(function () { btn.classList.remove('is-loading'); });
    });

    onCartUpdate(function () {
      fetchCart().then(function (cart) {
        var ids = cart.items.map(function (i) { return String(i.product_id); });
        var visible = 0;
        carousel.querySelectorAll('[data-slidecart-upsell-slide]').forEach(function (slide) {
          var inCart = ids.indexOf(slide.getAttribute('data-product-id')) > -1;
          slide.classList.toggle('is-in-cart', inCart);
          if (!inCart) visible++;
        });
        carousel.classList.toggle('is-single', visible <= 1);
        carousel.style.display = visible === 0 ? 'none' : '';
        updateScrollEnd();
      });
    });
  }

  /* Versandzeile */
  function initShippingLine() {
    var line = document.querySelector('[data-slidecart-shipping]');
    if (!line) return;
    var priceEl = line.querySelector('[data-slidecart-shipping-price]');
    var rateCents = parseInt(line.getAttribute('data-shipping-rate'), 10) || 0;
    var freeLimitCents = (parseInt(line.getAttribute('data-free-shipping-limit'), 10) || 0) * 100;
    var freeLabel = line.getAttribute('data-free-label') || 'Kostenlos';

    onCartUpdate(function () {
      fetchCart().then(function (cart) {
        var isFree = freeLimitCents > 0 && cart.total_price >= freeLimitCents;
        line.style.display = cart.item_count === 0 ? 'none' : '';
        if (priceEl) {
          priceEl.textContent = isFree ? freeLabel : formatMoney(rateCents);
          priceEl.classList.toggle('is-free', isFree);
        }
      });
    });
  }

  /* Eigene lineare Progress-Bar (Broadcast hat nur die Kreis-Grafik) */
  function initProgressBar() {
    var message = document.querySelector('.cart-dropdown__message');
    var bar = document.querySelector('[data-slidecart-progressbar]');
    if (!message || !bar) return;
    var limitCents = (parseInt(message.getAttribute('data-limit'), 10) || 0) * 100;
    if (!limitCents) return;

    onCartUpdate(function () {
      fetchCart().then(function (cart) {
        var pct = Math.min((cart.total_price / limitCents) * 100, 100);
        bar.style.width = pct + '%';
      });
    });
  }

  /* Kauf-Art in der Position umstellen (gleiches UI wie im Upsell):
     Einmalig/Abo-Toggle + Intervall-Chips, Wechsel via cart/change.js */
  function initLinePlanSwitch() {
    function changeLinePlan(holder, planId) {
      var item = holder.closest('[data-item]');
      if (item) item.style.opacity = '0.5';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          line: parseInt(holder.getAttribute('data-line'), 10),
          quantity: parseInt(holder.getAttribute('data-quantity'), 10) || 1,
          selling_plan: planId ? parseInt(planId, 10) : null,
        }),
      })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCartUI(); })
        .catch(function () {
          if (item) item.style.opacity = '';
        });
    }

    document.addEventListener('click', function (event) {
      var modeBtn = event.target.closest('[data-line-mode]');
      if (modeBtn) {
        if (modeBtn.classList.contains('is-active')) return;
        changeLinePlan(modeBtn.closest('[data-line-plans]'), modeBtn.getAttribute('data-line-mode'));
        return;
      }

      var planBtn = event.target.closest('[data-line-plan]');
      if (planBtn) {
        if (planBtn.classList.contains('is-active')) return;
        changeLinePlan(planBtn.closest('[data-line-plans]'), planBtn.getAttribute('data-line-plan'));
      }
    });
  }

  function init() {
    initLinePlanSwitch();
    initUpdateObserver();
    initHeaderCount();
    initPriority();
    initUpsell();
    initShippingLine();
    initProgressBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
